import { useEffect, useState } from "react";
import { Backdrop, CircularProgress, LinearProgress } from "@mui/material";
import { useApiLoading } from "../services/loadingTracker";

/** Las respuestas rápidas no muestran nada: evita el parpadeo. */
const RETARDO_MS = 300;

function useConRetardo(activo: boolean): boolean {
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        if (!activo) {
            setVisible(false);
            return;
        }
        const timer = setTimeout(() => setVisible(true), RETARDO_MS);
        return () => clearTimeout(timer);
    }, [activo]);
    return visible;
}

/**
 * Indicador de carga de todas las llamadas de apiClient: barra arriba para consultas y pantalla
 * bloqueada para guardar/modificar. Una llamada se excluye con `{ sinLoading: true }` en su config.
 */
export default function GlobalLoading() {
    const { total, bloqueantes } = useApiLoading();
    const barra = useConRetardo(total > 0);
    const bloqueo = useConRetardo(bloqueantes > 0);

    return (
        <>
            {barra && (
                <LinearProgress
                    color="primary"
                    sx={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: (theme) => theme.zIndex.tooltip + 1 }}
                />
            )}
            <Backdrop open={bloqueo} sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.modal + 1 }}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
}
